import type { FacilityWithCoordinates, Plan } from "../../@types";
import { MAPNET_MIN_PLAN_YEAR } from "../flag-hooks/useMapnetCoverage";
import { isMedicareAdvantageType } from "../planTypes";
import { useAppState } from "./useAppState";
import { useEnableFacilitiesManagement } from "./useEnableFacilitiesManagement";

/**
 * In reference to a specific plan, determines whether the page/card should show
 * facility-related UI. Made initially for use in the Plan Details page.
 * @returns an array of saved facilities or `false`, so doesn't need to be combined
 * with a check for `AppState.facilities`
 */
export const useFacilitiesForPlan = (
  plan: Partial<Plan>
): false | FacilityWithCoordinates[] => {
  const { facilities } = useAppState();
  // Because a hook can't be conditional, this is equivalent to saying "If there's
  // no plan.contract_year, the hook should return false." The hook will use
  // AppState.year, if a year isn't passed in.
  const enableFacilitiesManagement = useEnableFacilitiesManagement(
    plan?.contract_year ?? `${MAPNET_MIN_PLAN_YEAR - 1}`
  );
  return enableFacilitiesManagement &&
    plan?.plan_type &&
    isMedicareAdvantageType(plan.plan_type)
    ? facilities
    : false;
};
